<template>
  <div class="rem-main">
    为确保您的游戏体验，我们将在您使用我们的服务过程中申请以下权限，届时您可以选择同意或者拒绝开启相关权限，若是拒绝则会影响部分功能：
    <div >
      <h3>
         <img src="@/static/circle.png" alt="">
       <!-- <p class="check-big-box">
          <span class="check-box"></span>
        </p> -->
        存储权限
      </h3>
        向您提供保存图片、分享图片功能
    </div>
      <div>
        <h3>
          <img src="@/static/circle.png" alt="">
        <!-- <p class="check-big-box">
          <span class="check-box"></span>
        </p> -->
      手机/电话权限
      </h3>
      识别设备，用于检测防作弊等游戏安全功能
      </div>
      <div>
         <h3>
            <img src="@/static/circle.png" alt="">
        <!-- <p class="check-big-box">
          <span class="check-box"></span>
        </p> -->
      相机权限
      </h3>
      向您提供拍摄图片功能
      </div>
      <div>
         <h3>
            <img src="@/static/circle.png" alt="">
          <!-- <p class="check-big-box">
            <span class="check-box"></span>
          </p> -->
      位置权限
      </h3>
      向您提供地区排行榜功能
      </div>  
  </div>
</template>

<script >
  export default {
    beforeCreate(){
        document.querySelector('body').setAttribute('style','background: none');
    },
      //页面销毁之前执行
    beforeDestroy(){
      document.querySelector('body').removeAttribute('style');
    },
  }
</script>

<style lang="scss" scoped>
.rem-main {
  color:#A06D4E;
  font-size:.6875rem;
  font-family: "FZLTHK--GBK1-0";
  div{
    h3{
      .check-big-box{
        display: inline-block;
        width: 0.625rem;
        height: 0.625rem;
        border-radius:0.625rem;
        border:1px solid #666;
        line-height: 0.625rem;
        margin-left:.3125rem;
        text-align: center;
        .check-box{
          display: inline-block;
          width: 0.325rem;
          height: 0.325rem;
          border-radius:0.325rem;
          margin-bottom:.188rem;
          background: #666;
        }
      }
    }
  }
  // .check-big-box{
  //     display: inline-block;
  //     width: 0.625rem;
  //     height: 0.625rem;
  //     border-radius:0.625rem;
  //     border:1px solid #666;
  //     line-height: 0.625rem;
  //     margin-left:.3125rem;
  //     text-align: center;
  //   .check-box{
  //     display: inline-block;
  //     width: 0.325rem;
  //     height: 0.325rem;
  //     border-radius:0.325rem;
  //     margin-bottom:.188rem;
  //     background: #666;
  //     }
  //   }
}

</style>